export default 'https://tme.understood.org/assets/pizza.ba2fe1db.glb'